import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=73137060&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=73137060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73137060",
  null
  
)

export default component.exports